export const view = {
    methods: {
        selectBranch: function (e) {
            e.preventDefault();
            var _self = this;
            var target = e.target.closest('div[name=BranchContainer]');
            document.querySelector('form[name=BranchSelectContainer] div[name=BranchContainer]').classList.remove('selected');
            target.classList.add('selected');
            var franchiseName = _self.getUrlParameter('franchise');
            var branchID = target.getAttribute('data-id');

            if (localStorage.franchiseName == franchiseName || localStorage.franchiseUrlFriendlyOrderName == franchiseName) {
                localStorage.branchID = branchID;
                var returnUrl = this.$route.query.returnUrl;
                if (returnUrl)
                    this.redirect(returnUrl);
                else
                    this.$router.push({ path: 'Menu', query: { franchise: franchiseName }});
            }
            else
                this.$router.push('Franchise')
        }
    }
}